import React from 'react'
import { Heading } from '@shopify/polaris'
import './render_image.css'
import ModalImage from '../modal-image/ModalImage'
import ModalVideo from '../modal-video/ModaVideo'
import LikeIcon from '../icons/LikeIcon'
import addImageToLocalStorage from '../../scripts/addImageToLocalStorage'
import removeImageInLocalStorage  from '../../scripts/removeImageInLocalStorage';
import VideoIcon from '../icons/VideoIcon'
  
class RenderImages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      images: this.props.images, // Arr[{value}, {value}]
      localStorageName: this.props.localStorageName
    }
    this.likeImg = this.likeImg.bind(this)
  }
  
  likeImg(index, image_date, image){
    if (this.props.images[index].like === true) {
      this.setState({
        images: this.props.images[index].like = false
      });
      removeImageInLocalStorage(this.props.localStorageName, image_date)
    } else {
      this.setState({
        images: this.props.images[index].like = true
      });
      addImageToLocalStorage(this.props.localStorageName, image_date, image);
    }
  }

  render() {
    const images = this.props.images.map((image, index) => {

      if (image.media_type === 'image') {
        return <li key={index} index={index} className='images-wrapper__item'>
            <div className='images-wrapper__item__content'>
              <div className='images-wrapper__item__content__img'>
                <img src={image.url} alt={image.title} width={250}></img>
                <div onClick={() => this.likeImg(index, image.date, image)} className='images-wrapper__item-content__details-like'>
                  <LikeIcon like={image.like}/>
                </div>
              </div>
              <div className='images-wrapper__item-content__details'>
                
                <Heading>{image.title}</Heading>
                <p>{image.description_short}</p>

                <div className='images-wrapper__item-content__details-bottom'>
                  <div className='left'>
                    <p>{image.date}</p>
                    <p>{image.copyright}</p>
                  </div>
                  <div className='right'>
                    <ModalImage 
                      img_url={image.url}
                      date={image.date}
                      title={image.title}
                      description={image.explanation}
                      copyright={image.copyright}
                    />
                  </div>
                </div>  
              </div>
            </div>
        </li>
      }  else {
        return <li key={index} index={index} className='images-wrapper__item'>
          <div className='images-wrapper__item__content'>
            <div className='images-wrapper__item__content__img'>
              <img src={image.youtube_preview} alt={image.title} width={250}></img>
              <VideoIcon />
              <div onClick={() => this.likeImg(index, image.date, image)} className='images-wrapper__item-content__details-like'>
                <LikeIcon like={image.like}/>
              </div>
            </div>
            <div className='images-wrapper__item-content__details'>
              <Heading>{image.title}</Heading>
              <p>{image.description_short}</p>

              <div className='images-wrapper__item-content__details-bottom'>
                  <div className='left'>
                    <p>{image.date}</p>
                    <p>{image.copyright}</p>
                  </div>
                  <div className='right'>
                    <ModalVideo 
                      date={image.date}
                      title={image.title}
                      description={image.explanation}
                      id_video={image.youtube_id}
                      copyright={image.copyright}
                    />
                  </div>
                </div>  
            </div>
          </div>
        </li>}
  }) 

    return <div>
      <ul className="images-wrapper">{images}</ul>
    </div>
  }
} 
 
export default RenderImages